// Carries a "run this request" example from a scrapingant.com landing page through signup/login into the Request generator.
// Contract: /signup?example=markdown&url=<https URL>&browser=true|false (same on /login). Unknown or invalid values are ignored.
import { getCookie, setCookie, deleteCookie } from "@/utils/common_utils";

const COOKIE = "pending_example";
const DOMAIN = window.location.hostname.endsWith("scrapingant.com") ? ".scrapingant.com" : undefined;
const EXAMPLES = ["general", "extended", "markdown", "extract"];

export function readPendingExampleFromQuery(route) {
  const q = (route && route.query) || {};
  if (!EXAMPLES.includes(q.example)) return null;
  let url = null;
  try {
    const parsed = new URL(String(q.url || ""));
    if (parsed.protocol === "https:") url = parsed.toString();
  } catch (e) {
    url = null;
  }
  if (!url) return null;
  const example = { example: q.example, url, browser: q.browser !== "false" };
  setCookie(COOKIE, JSON.stringify(example), 7, DOMAIN);
  return example;
}

export function takePendingExample() {
  const raw = getCookie(COOKIE);
  if (!raw) return null;
  deleteCookie(COOKIE, DOMAIN);
  try {
    const example = JSON.parse(decodeURIComponent(raw));
    if (!EXAMPLES.includes(example.example) || typeof example.url !== "string") return null;
    return example;
  } catch (e) {
    return null;
  }
}

// vue-auth calls this only after confirming a signed-in user is entering a
// guest-only route. Go straight to the example, avoiding a duplicate Dashboard
// navigation that would prevent the router's beforeResolve hook from running.
export function authenticatedGuestRedirect(route) {
  const pending = route.name === "Signup" || route.name === "Login" ? takePendingExample() : null;
  if (!pending) return { name: "Dashboard" };
  return {
    name: "WebScrapingAPI",
    query: { response_type: pending.example, url: pending.url, browser: String(pending.browser) },
  };
}
